import React from 'react';
import { Link } from 'react-router';

const Navigation: React.FC = () => {
  return (
    <nav className="bg-gray-100 p-4 mb-4">
      <ul className="flex list-none m-0 p-0">
        <li className="mr-4">
          <Link
            to="/"
            className="text-gray-800 no-underline font-bold hover:underline"
          >
            Home
          </Link>
        </li>
        <li className="mr-4">
          <Link
            to="/blocks"
            className="text-gray-800 no-underline font-bold hover:underline"
          >
            Blocks
          </Link>
        </li>
        <li className="mr-4">
          <Link
            to="/squiggles"
            className="text-gray-800 no-underline font-bold hover:underline"
          >
            Squiggles
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
